<template>
  <div>
    <a-button
      type="primary"
      style="margin-left: 10px; margin-bottom: 1em;"
      @click.prevent="goToCreatePost"
    >New Post</a-button>
    <a-table
      :columns="columns"
      :data-source="posts"
      :loading="fetchingData"
      :row-key="record => record.id"
    >
      <span slot="actions" slot-scope="text, record">
        <router-link :to="getEditLink(record.id)">Edit</router-link>
        <a-divider type="vertical" />
        <a href="#">Delete</a>
      </span>

      <span slot="created_at" slot-scope="text, record">{{record.created_at.format("DD-MM-YYYY")}}</span>

      <span slot="published" slot-scope="text, record">
        <a-switch :checked="record.publishDate != null" disabled />
      </span>
    </a-table>
  </div>
</template>

<script>
import firebase from "@/configs/firebase-setup";
import moment from "moment";
const db = firebase.firestore();

export default {
  data() {
    return {
      fetchingData: true,
      columns: [
        {
          title: "Actions",
          key: "actions",
          scopedSlots: { customRender: "actions" }
        },
        {
          dataIndex: "game",
          title: "Game",
          key: "game",
          sorter: true
        },
        {
          dataIndex: "title",
          title: "Title",
          key: "title",
          sorter: true
        },
        {
          dataIndex: "created_at",
          title: "Created Date",
          key: "created_at",
          scopedSlots: { customRender: "created_at" },
          sorter: true
        },
        {
          dataIndex: "published",
          title: "Published",
          key: "published",
          scopedSlots: { customRender: "published" }
        }
      ],
      posts: []
    };
  },

  created() {
    if (firebase.auth().currentUser == null) {
      this.$router.push({ name: "LoginAdmin" });
    }
  },

  async mounted() {
    await this.getPosts();
  },

  methods: {
    getPosts() {
      this.fetchingData = true;
      db.collection("posts")
        .orderBy("created_at", "desc")
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            const data = doc.data();
            data.id = doc.id;
            data.key = data.id;
            data.created_at = moment(data.created_at);
            this.posts.push(data);
          });

          this.posts.sort((a, b) => {
            return a.created_at;
          });

          this.fetchingData = false;
        });
    },

    getEditLink(id) {
      return `/admin/${id}/edit`;
    },

    goToCreatePost() {
      this.$router.push({ name: "CreatePost" });
    }
  }
};
</script>